<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="`left`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :md="8">
            <el-form-item :label="$t('매장')">
              <StorePicker v-model="searchForm.storeCd" :options="store" @change="search" />
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item :label="$t('카테고리명')">
              <el-input v-model="searchForm.categoryNm" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('CategorySearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <el-button
        v-if="checkAuthActionAccess('CategoryAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('CategoryUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('CategoryDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @row-click="handleRowClick"
      @select="handleRowChecked"
      @select-all="handleRowChecked">
      <el-table-column
        :label="tableData.length.toString()"
        type="index"
        width="55"
        align="center"
        sortable
        label-class-name="data_cnt"></el-table-column>
      <el-table-column type="selection" width="45" align="center"></el-table-column>
      <el-table-column
        :label="$t('카테고리명')"
        prop="categoryNmLan"
        min-width="200"
        sortable
        show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('표시 순서')" prop="ord" min-width="115" align="center" sortable>
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.ord"
            @change="handleChangeOrd(scope.row)"
            :min="1"
            :max="99"
            size="mini"
            style="width: 90px"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('사용 가능 여부')"
        prop="useYn"
        min-width="100"
        align="center"
        :formatter="mainVue.formatterCode"></el-table-column>
      <!--			<el-table-column :label="$t('설명')" 			prop="categoryDesc" min-width="300" show-overflow-tooltip></el-table-column>-->
    </el-table>

    <!-- 입력 팝업 -->
    <el-dialog :title="inputForm.title" :visible.sync="dialogFormVisible" fullscreen>
      <el-form
        :model="inputForm"
        label-width="140px"
        :label-position="$device.mobile ? 'top' : 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row :gutter="20">
          <el-col :md="inputForm.categoryInfos.length > 0 ? 12 : 24">
            <el-tabs value="info">
              <el-tab-pane :label="$t('기본 정보')" name="info">
                <el-row :gutter="20">
                  <el-col :span="inputForm.categoryInfos.length > 0 ? 24 : 12">
                    <el-form-item :label="$t('매장')" required>
                      <StorePicker
                        v-if="'I' === inputForm.statu"
                        v-model="inputForm.store.storeCd"
                        :options="store"
                        @change="storeInputSelect" />
                      <span v-else class="show_cd">{{ inputForm.store.storeNmLan }}</span>
                    </el-form-item>

                    <el-form-item :label="$t('카테고리명')" :error="formError.categoryNm" required>
                      <el-input v-model="inputForm.categoryNm" maxlength="50" clearable show-word-limit>
                        <el-button
                          v-if="lans.length > 1"
                          slot="append"
                          :size="size"
                          @click="dictionaryDialogFormVisible = true"
                          icon="el-icon-search"
                          >{{ $t('다국어 조회') }}</el-button
                        >
                      </el-input>

                      <!-- 사전 선택 -->
                      <DictionaryDialog
                        :visible="dictionaryDialogFormVisible"
                        @close="dictionaryDialogFormVisible = false"
                        @selectDictionary="selectDictionary" />
                    </el-form-item>

                    <el-form-item :label="$t('표시 순서')" :error="formError.ord" required>
                      <el-input-number v-model="inputForm.ord" :min="1" :max="99"></el-input-number>
                    </el-form-item>

                    <el-form-item :label="$t('사용 가능 여부')" required>
                      <combo
                        :data="mainVue.code.useYn"
                        :model="inputForm.useYn"
                        @change="inputForm.useYn = $event"></combo>
                    </el-form-item>

                    <!--										<el-form-item :label="$t('설명')" :error="formError.categoryDesc">-->
                    <!--											<el-input v-model="inputForm.categoryDesc" type="textarea" maxlength="250" show-word-limit></el-input>-->
                    <!--										</el-form-item>-->
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </el-col>
          <el-col :md="12" v-if="inputForm.categoryInfos.length > 0">
            <el-tabs v-model="activiTab">
              <el-tab-pane
                v-for="(item, index) in inputForm.categoryInfos"
                :key="item.lanTp.id"
                :label="item.lanTp.nm"
                :name="item.lanTp.id">
                <el-form-item
                  :label="$t('카테고리명')"
                  :error="formError['categoryInfos[' + index + '].categoryInfoNm']"
                  required>
                  <el-input
                    v-model="inputForm.categoryInfos[index].categoryInfoNm"
                    maxlength="50"
                    clearable
                    show-word-limit></el-input>
                </el-form-item>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button icon="el-icon-check" :size="size" @click="save" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
        <el-button icon="el-icon-close" :size="size" @click="closeDialogVisible = true">{{ $t('닫기') }}</el-button>
        <el-dialog
          title="Warning"
          :visible.sync="closeDialogVisible"
          width="300px"
          :modal="false"
          :modal-append-to-body="false"
          :append-to-body="true"
          center>
          <span>정말로 페이지를 닫으시겠습니까?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialogVisible = false">아니요</el-button>
            <el-button
              type="primary"
              @click="
                closeDialogVisible = false
                dialogFormVisible = false
              "
              >예</el-button
            >
          </span>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 대리점
import DictionaryDialog from '@/components/dictionary/DictionaryDialog.vue'
import StorePicker from '@/components/store/StorePicker.vue'
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'
import { initData } from '@/utils/constants'
import { STORE_OPTIONS_API, firstStoreOf, storeLansOf, storeOptionsOf, storeOptionsQuery } from '@/utils/storeOptions'
import storeOptionResolver from '@/mixins/storeOptionResolver'

export default {
  mixins: [mainVueMixin, storeOptionResolver],

  components: {
    DictionaryDialog,
    StorePicker,
  },

  data: function () {
    var data = initData()
    data.url = '/category'
    data.store = []
    data.activiTab = ''

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    data.lans = []
    data.popTableData = []

    data.dictionaryDialogFormVisible = false
    data.searchText = ''

    data.closeDialogVisible = false
    return data
  },
  created: function () {
    this.initStore()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    formError: {
      deep: true,
      handler: function (newVal, oldVal) {
        // 벨리데이션 메세지가 값은 있는데 Vue에서 표시 안해주는 현상 처리 하기 위함
        setTimeout(
          function () {
            var tmp = this.inputForm.categoryNm
            this.inputForm.categoryNm = this.inputForm.categoryNm + ' '
            this.inputForm.categoryNm = tmp

            var i = 100
            for (let val in newVal) {
              if (val.indexOf('categoryInfos') > -1) {
                if ('' != newVal[val]) {
                  if (i > val.replace(/[^0-9]*/g, '')) {
                    i = parseInt(val.replace(/[^0-9]*/g, ''))
                  }
                }
              }
            }

            if (100 != i) {
              this.activiTab = this.inputForm.categoryInfos[i].lanTp.id
            }
          }.bind(this),
          500
        )
      },
    },
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        storeCd: null,
        categoryNm: '',
        useYn: 'Y',
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        title: '',
        categoryCd: 0,
        defaultLan: { id: '' },
        categoryNm: '',
        categoryInfos: [],
        store: { storeCd: null },
        ord: 0,
        useYn: 'Y',
        categoryDesc: '',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        categoryNm: '',
        ord: '',
        useYn: '',
        categoryDesc: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].categoryCd
      }
    },
    // 매장 자동 검색 — 셀렉트 전용 경량 조회다. URL·조건은 [storeOptionsQuery] 한 곳이 소유한다
    initStore: function () {
      this.mainVue.$axios.search(
        STORE_OPTIONS_API,
        storeOptionsQuery(),
        function (result) {
          this.store = storeOptionsOf(result)

          // 매장이 하나도 없는 계정(사업장 없음)은 빈 셀렉트·빈 표가 옳다 — 매장 축 없는 목록 조회는
          // 서버가 거절하므로 조회 자체를 건너뛴다
          const first = firstStoreOf(this.store)
          if (first == null) return

          // 검색 칸의 기본 매장은 [StorePicker] 가 소유한다 — 후보를 아는 곳이 거기뿐이고,
          // 화면마다 복제하면 칸이 없는 자리(매장 계정 발급)에서 값이 비는 사고가 난다.
          // 첫 조회도 그 칸의 `change` 가 부른다
          this.inputForm.store.storeCd = first.storeCd
          this.inputForm.defaultLan = first.defaultLan

          this.initStoreLans(first)
        }.bind(this)
      )
    },
    // 사전 조회를 위한 언어 정보 설정
    // 순서(기본 언어가 맨 앞)는 [storeLansOf] 한 곳이 소유한다
    initStoreLans: function (store) {
      this.lans = storeLansOf(store)
    },
    // 고른 매장의 메타데이터를 폼에 적는다 — 진입점 둘(사람·씨앗)은 [storeOptionResolver] 가 갖고
    // 화면은 이 본문만 구현한다. 못 얻으면 아무것도 바꾸지 않는다
    applyStoreOption: async function (storeCd, pending) {
      const option = await pending
      if (!option) return

      // 디폴트 언어 설정
      this.inputForm.defaultLan = option.defaultLan
      this.initStoreLans(option)

      // 수정 시 매장 다국어 삭제 시 카테고리도 다국어 지워줌
      var categoryInfosTmp = []

      if (this.inputForm.statu == 'U') {
        categoryInfosTmp = util.copyObj(this.inputForm.categoryInfos)
      }

      this.inputForm.categoryInfos = []

      for (var j = 0, jlen = option.lans.length; j < jlen; j++) {
        this.formError['categoryInfos[' + j + '].categoryInfoNm'] = ''

        var categoryInfoNm = ''

        if (this.inputForm.statu == 'U') {
          for (var k = 0, klen = categoryInfosTmp.length; k < klen; k++) {
            if (categoryInfosTmp[k].lanTp.id == option.lans[j].id) {
              categoryInfoNm = categoryInfosTmp[k].categoryInfoNm
            }
          }
        }

        this.inputForm.categoryInfos.push({
          lanTp: option.lans[j],
          categoryInfoNm: categoryInfoNm,
        })

        if (j === 0) {
          this.activiTab = option.lans[j].id
        }
      }
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      this.inputForm.title = this.$t('카테고리 추가')
      this.formError = this.initFormError()

      if (this.store.length > 0) {
        this.inputForm.store = { storeCd: util.copyObj(this.searchForm.storeCd) }
        this.storeSeedSelect(this.inputForm.store.storeCd)
      }

      // 순번 자동으로 검색된 내용중 제일 마지막으로 설정
      for (var i = 0, len = this.tableData.length; i < len; i++) {
        if (this.inputForm.ord < this.tableData[i].ord) {
          this.inputForm.ord = this.tableData[i].ord
        }
      }

      this.inputForm.ord++

      this.dialogFormVisible = true
      this.btn.saveDisabled = false
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.categoryCd,
        function (result) {
          result.statu = 'U'
          result.title = this.$t('카테고리 수정')

          this.inputForm = result

          this.formError = this.initFormError()

          this.storeSeedSelect(this.inputForm.store.storeCd)

          this.dialogFormVisible = true
          this.btn.saveDisabled = false
        }.bind(this),
        true
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchForm,
        function (result) {
          this.tableData = result

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('카테고리 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      for (var i = 0, len = this.inputForm.categoryInfos.length; i < len; i++) {
        this.formError['categoryInfos[' + i + '].categoryInfoNm'] = ''
      }

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.categoryCd,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      }
    },
    searchDictionary: function () {
      this.mainVue.$axios.search(
        '/dictionary/search',
        { nm: this.searchText, dictionaryTpVal: 'category' },
        function (result) {
          this.popTableData = []

          for (var i = 0, len = result.length; i < len; i++) {
            var tmp = result[i]

            tmp[result[i].lan.id] = result[i].nm

            for (var j = 0, jlen = result[i].dictionarys.length; j < jlen; j++) {
              tmp[result[i].dictionarys[j].lan.id] = result[i].dictionarys[j].nm
            }

            this.popTableData.push(tmp)
          }
        }.bind(this),
        true
      )
    },
    // 키워드 데이타 선택
    selectDictionary: function (row) {
      for (var i = 0, len = this.lans.length; i < len; i++) {
        // 기본 언어 새팅
        if (0 == i) {
          this.inputForm.categoryNm = row[this.lans[i].id]
        } else {
          // 타언어 순서대로 등록
          this.inputForm.categoryInfos[i - 1].categoryInfoNm = row[this.lans[i].id]
        }
      }

      this.dictionaryDialogFormVisible = false
    },
    // 순서 수정
    handleChangeOrd: function (row) {
      this.mainVue.$axios.patchNonLoading(this.url + '/' + row.categoryCd + '/' + row.ord)
    },
  },
}
</script>
